import TextField from '@mui/material/TextField'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'

const validationSchema = yup.object({
    name: yup.string().trim().required('Название обязательное'),
})

export const RecordRenameDialog = ({ open, handleClose, record }) => {
    const { updateRecord, isLoadingUpdateRecord } = useAssistantAdministrationStore(
        (state) => state,
    )

    const { values, handleBlur, handleChange, handleSubmit, touched, dirty, isValid, errors } =
        useFormik({
            initialValues: {
                name: record.title,
            },
            validationSchema: validationSchema,
            onSubmit: async (values) => {
                await updateRecord({ recordId: record.id }, { title: values.name })
                handleClose()
            },
        })

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            title="Переименовать запись"
            submitButtonText="Переименовать"
            colorSubmitButton="primary"
            isDisabled={!(isValid && dirty) || isLoadingUpdateRecord}>
            <TextField
                fullWidth
                id="name"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                variant="outlined"
                label="Название"
            />
        </ConfirmDialogWrapper>
    )
}
